export enum MatchCategory {
  TOP_RECOMMENDED = 'top_recommended',
  GREAT_WITH_NEW_CLIENTS = 'top_engagement',
  OTHER_TOP_SCORERS = 'other_top_scorers',
  NEEDS_A_MATCH = 'needs_a_match',
  RANDOM = 'random'
}

export const NonDisplayedMatchCategories = new Set([
  MatchCategory.NEEDS_A_MATCH,
  MatchCategory.RANDOM
]);

export enum CalculatedCategory {
  PENDING_SESSION = 'pending_session',
  SCHEDULE_NOW = 'schedule_now',
  PAUSED_OR_REACTIVATED = 'paused_or_reactivated',
  MESSAGED_PROVIDERS = 'messaged_providers',
  PROVIDERS_WHO_WILL_REACH_OUT = 'providers_who_will_reach_out'
}

export type DashboardCategory = CalculatedCategory | MatchCategory;
